import { render, staticRenderFns } from "./LocationSettingsBasic.vue?vue&type=template&id=6bdac8a0&scoped=true"
import script from "./LocationSettingsBasic.vue?vue&type=script&lang=js"
export * from "./LocationSettingsBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdac8a0",
  null
  
)

export default component.exports